import axios from 'axios'
import JSZip from 'jszip'
import {toCSV} from 'shared/csv';
import moment from 'moment'
var FileSaver = require('file-saver');

const downloader=function(stories, filename, onProgress){
  let state={
    progress:0,
    percentage:0,
    status:"waiting"
  }
  const changeState=(status,progress)=>{
    state={
      progress,
      percentage:Math.round((progress*100)/stories.length),
      status
    }
    if(onProgress){onProgress(state)}
  }
  const loadMedia=(story)=>{
    return new Promise((resolve, reject)=>{
      axios.get(story.url+"&v="+Math.random(1000000),
        { responseType:"blob" }
      ).then(res=>{
        changeState("downloading", state.progress+1)
        const s=Object.assign({}, story, {
          file:{
            data:res.data,
            name:moment(story.posted_at).format('YYYY-MM-DD h-mm')+(story.type==="VIDEO" ? ".mp4" : ".jpg")
          }
        })
        resolve(s)
      })
      .catch(err=>{
        changeState("downloading", state.progress+1)
        resolve()
      })
    })
  }

  const zipFiles=(filename, stories)=>{
    changeState("zipping", stories.length)
    var zip = new JSZip();
    var zipFolder = zip.folder(filename);
    stories.forEach((story,index)=>{
      //changeState("zipping", state.progress+1)
      if(story.file){zipFolder.file(story.file.name, story.file.data, {base64: true})}
    })
    zipFolder.file("export.csv", createCSVFile(stories))
    changeState("finishing", stories.length)
    zip.generateAsync({type:"blob"})
    .then(function(content) {
        changeState("done", stories.length)
        FileSaver.saveAs(content, filename+".zip");
    });
  }

  const createCSVFile=(stories)=>{
    changeState("csv", stories.length)
    let data=[
      ["posted_at","type","impressions","reach","replies","exits","taps_forward","taps_back","file_name"]
    ]
    stories.forEach(s=>data.push([s.posted_at, s.type, s.insights.impressions, s.insights.reach, s.insights.replies, s.insights.exits, s.insights.taps_forward, s.insights.taps_back, s.file.name]))
    return toCSV(data)
  }
  Promise.all(stories.map(loadMedia))
         .then(storiesWithFile=>{
           return zipFiles(filename, storiesWithFile)
         })
         .then(zip=>{
           changeState("finishing", stories.length)
         })
}

export default downloader;



// WEBPACK FOOTER //
// ./src/shared/download_stories.js